/*
    this function adds polyfill smooth scrolling for all browsers
   @param time: the exact amount of time the scrolling will take (in milliseconds)
   @param pos: the y-position to scroll to (in pixels)
*/
export default function horizontalScrollAnimation(
  element: HTMLElement,
  pos: number,
  time: number
) {
  const currentPos = element.scrollLeft;
  let start = null;
  // eslint-disable-next-line no-param-reassign
  if (time == null) time = 500;
  // eslint-disable-next-line no-param-reassign
  ((pos = +pos), (time = +time));
  window.requestAnimationFrame(function step(currentTime) {
    start = !start ? currentTime : start;
    const progress = currentTime - start;
    if (currentPos < pos) {
      element.scrollTo(((pos - currentPos) * progress) / time + currentPos, 0);
    } else {
      element.scrollTo(currentPos - ((currentPos - pos) * progress) / time, 0);
    }
    if (progress < time) {
      window.requestAnimationFrame(step);
    } else {
      element.scrollTo(pos, 0);
    }
  });
}
